import { createFileRoute, Outlet } from "@tanstack/react-router";
export const Route = createFileRoute("/learn")({
  component: LayoutComponent,
  head() {
    return {
      meta: [
        {
          title: "Learn: Depression Treatment Guides | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Expert guides on SAINT® TMS, standard TMS, SPRAVATO®, and treatment-resistant depression. Medically reviewed resources from Neuro Wellness in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Learn: Depression Treatment Guides | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Expert guides on SAINT® TMS, standard TMS, SPRAVATO®, and treatment-resistant depression. Medically reviewed resources from Neuro Wellness in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/learn",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      // No canonical here — this is a pathless layout route. A canonical set
      // here would be merged into every child learn/* route's head() and
      // produce a duplicate, wrong canonical. The /learn leaf (learn.index.tsx)
      // and each child route emit their own self-referencing canonical.
    };
  },
});
function LayoutComponent() {
  return <Outlet />;
}
